import src from "IMAGE";
export default { src, width: 1715, height: 650, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAARUlEQVR42m3DsQkAMQgAQPnG+pvvhDiBOMFv4aLfuMSXGSNYBmyS1CEHB5nZx0FENDN7oS7/gbt/IlJAVQszP3siuhHxmkoiNzyQuRuYAAAAAElFTkSuQmCC"};
